import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { Label } from "@/components/ui/label";

export interface PersonModelInterface {
    detailInfo: {
        firstName: string;
        secondName: string;
        lastName: string;
        phoneNumber: string;
        individualNumber: string;
        idPassport: string;
        address: string;
        city: string;
        placeOfWork: string;
    };
    phone: {
        phoneModel: string;
        imei: string;
        icloud: string;
        password: string;
        costPrice: number;
        condition: string;
        registrationNumber: string;
    };
    status: string;
    creditor: string;
    creditDetail: {
        phoneAmount: number;
        downPayment: number;
        percent: number;
        term: number;
        monthlyPayment: number;
        total: number;
        closingDay: string;
        releaseDay: string;
        netProfit?: number;
    };
    guarantees?: any[];
}

const PhoneNumberInput: React.FC = () => {
    const {
        control,
        formState: { errors },
    } = useFormContext<PersonModelInterface>();

    const errMsg = errors?.detailInfo?.phoneNumber?.message as string | undefined;

    return (
        <div className="w-full space-y-2">
            <Controller
                name="detailInfo.phoneNumber"
                control={control}
                rules={{
                    required: "Обязательное поле",
                    validate: (value) => {
                        if (!/^(7|996)\d{9,10}$/.test(value)) {
                            return "Некорректный номер телефона";
                        }
                        return true;
                    },
                }}
                render={({ field }) => (
                    <>
                        <div
                            className={[
                                "rounded-md border transition-colors",
                                errMsg
                                    ? "border-destructive focus-within:ring-1 focus-within:ring-destructive"
                                    : "border-input focus-within:ring-1 focus-within:ring-ring",
                            ].join(" ")}
                        >
                            <PhoneInput
                                onlyCountries={["kg", "ru"]}
                                country="kg"
                                value={field.value || ""}
                                onChange={(val: string) => field.onChange(val)}
                                inputProps={{
                                    name: "phone",
                                    required: true,
                                    autoComplete: "off",
                                }}
                                containerStyle={{ width: "100%" }}
                                inputStyle={{
                                    width: "100%",
                                    height: "40px",
                                    border: "none",
                                    paddingLeft: "48px",
                                    fontSize: "14px",
                                    background: "transparent",
                                }}
                                buttonStyle={{
                                    border: "none",
                                    background: "transparent",
                                }}
                                dropdownStyle={{
                                    zIndex: 50,
                                }}
                                placeholder="Введите номер"
                                specialLabel=""
                            />
                        </div>

                        {errMsg ? <p className="text-xs text-destructive">{errMsg}</p> : null}
                    </>
                )}
            />
        </div>
    );
};

export default PhoneNumberInput;
